import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
 
import Header from './components/Header';
import LandingPage from './components/LandingPage';

import About from './pages/About';
import Services from './pages/Services';
import ScrollToTop from "./components/ScrollToTop";

import Product from './pages/Product';
import Contactus from './pages/Contactus';

// Products sub-pages
import HisPage from './pages/HisPage';
import EhrPage from './pages/EhrPage';
import RcmPage from './pages/RcmPage';
import LimsPage from './pages/LimsPage';

// Services sub-pages
import Medical from "./pages/Medical";
import Analysis from "./pages/Analysis";
import Detection from "./pages/Detection";

import React, { useEffect } from "react";

function App() {

  useEffect(() => {
    const metaTag = document.querySelector('meta[name="viewport"]');

    if (metaTag) {
      metaTag.setAttribute('content', 'width=1024');
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'viewport';
      newMeta.content = 'width=1024';
      document.head.appendChild(newMeta);
    }

    document.documentElement.style.overflowX = "auto";
    document.body.style.overflowX = "auto";
  }, []);

  return (
   <div className="w-full min-w-[1024px] mx-auto page-container">
      
      {/* ✅ USE ONLY ONE ROUTER */}
      <Router>

        {/* 🔥 ScrollToTop FIX */}
        <ScrollToTop />

        {/* Header Always Visible */}
        <Header />

        <div className="w-full min-w-[1024px] mx-auto">

          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/products" element={<Product />} />
            <Route path="/contact" element={<Contactus />} />

            <Route path="/analysis" element={<Analysis />} />
            <Route path="/detection" element={<Detection />} />
            <Route path="/medical" element={<Medical />} />

            <Route path="/his" element={<HisPage />} />
            <Route path="/ehr" element={<EhrPage />} />
            <Route path="/rcm" element={<RcmPage />} />
            <Route path="/lims" element={<LimsPage />} />
          </Routes>

        </div>

      </Router>
    </div>
  );
}

export default App;